import { Injectable } from '@angular/core';
import { ConstraintOptions, ConstraintPromptResponse, MailConstraintHandler, MailParams } from '@shared/modules/mailing';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NoopConstraintHandler extends MailConstraintHandler {
    public check(params: MailParams, options: ConstraintOptions<any>): boolean | Observable<boolean> | Promise<boolean> { return true; }
    public resolve(params: MailParams, options: ConstraintOptions<any>): boolean | Observable<boolean> | Promise<boolean> { return true; }
    public prompt(params: MailParams, options: ConstraintOptions<any>): ConstraintPromptResponse<any> | Observable<ConstraintPromptResponse<any>> | Promise<ConstraintPromptResponse<any>> { return null; }
}